import React, { useMemo } from 'react';
import Ionicons from '@expo/vector-icons/Ionicons';
import type { StyleProp, ViewStyle } from 'react-native';
import { StyleSheet, Text, View } from './rn';
import { ThemeColors } from '../theme';
import { useTheme } from '../theme/ThemeContext';
import { useTranslation } from '../i18n/I18nContext';
import { useUnread } from '../unread/UnreadContext';
import { formatBadgeCount } from '../unread/badge';
import GlassControlButton from './GlassControlButton';

type Props = {
  onPress: () => void;
  style?: StyleProp<ViewStyle>;
};

export default function NotificationBellButton({ onPress, style }: Props) {
  const colors = useTheme();
  const { t, lang } = useTranslation();
  const { notifications } = useUnread();
  const styles = useMemo(() => makeStyles(colors), [colors]);
  const label = notifications > 0
    ? t('notifications.centerBellUnread', { count: notifications })
    : t('notifications.centerBell');

  return (
    <GlassControlButton onPress={onPress} accessibilityLabel={label} style={style}>
      <Ionicons name="notifications-outline" size={22} color={colors.black} />
      {notifications > 0 && (
        <View style={styles.badge} pointerEvents="none">
          <Text style={styles.badgeText} numberOfLines={1}>
            {formatBadgeCount(notifications, lang)}
          </Text>
        </View>
      )}
    </GlassControlButton>
  );
}

const makeStyles = (colors: ThemeColors) => StyleSheet.create({
  // Rozet dairenin kenarına biniyor: 40 pt'lik yuvarlağın içinde kalsaydı
  // sembolü örterdi. GlassControlButton `overflow: 'visible'` taşıdığı için
  // taşma kırpılmıyor — cam yüzeyin gölgesi de aynı sebeple dışarı çizilebiliyor.
  badge: {
    position: 'absolute',
    top: -2,
    right: -2,
    minWidth: 18,
    height: 18,
    borderRadius: 9,
    paddingHorizontal: 4,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#1473E6',
    borderWidth: 2,
    borderColor: colors.white,
  },
  badgeText: {
    color: '#FFFFFF',
    fontSize: 10,
    lineHeight: 12,
    fontWeight: '700',
  },
});
